"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[444],{

/***/ 10572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HY": function() { return /* binding */ filterTypesByActivityTypeID; },
/* harmony export */   "IV": function() { return /* binding */ PAGE_SIZE; },
/* harmony export */   "m9": function() { return /* binding */ fieldNameByActivityFilterType; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);
/* harmony import */ var constants_enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35460);



var _obj;
var filterTypesByActivityTypeID = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY, [
    {
        filterType: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.CATEGORY */ .Kx0.CATEGORY,
        name: "활동분야"
    },
    {
        filterType: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.INTEREST */ .Kx0.INTEREST,
        name: "관심분야"
    },
    {
        filterType: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.BENEFIT */ .Kx0.BENEFIT,
        name: "활동혜택"
    },
    {
        filterType: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.PERIOD */ .Kx0.PERIOD,
        name: "활동기간"
    },
    {
        filterType: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.REGION */ .Kx0.REGION,
        name: "모임지역"
    },
    {
        filterType: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.ORGANIZATION */ .Kx0.ORGANIZATION,
        name: "주최기관"
    }, 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CLUB */ .kF.CLUB, [
    {
        filterType: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.CATEGORY */ .Kx0.CATEGORY,
        name: "활동분야"
    },
    {
        filterType: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.INTEREST */ .Kx0.INTEREST,
        name: "관심분야"
    },
    {
        filterType: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.REGION */ .Kx0.REGION,
        name: "모임지역"
    },
    {
        filterType: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.TARGET */ .Kx0.TARGET,
        name: "모임대상"
    }, 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CONTEST */ .kF.CONTEST, [
    {
        filterType: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.CATEGORY */ .Kx0.CATEGORY,
        name: "공모분야"
    },
    {
        filterType: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.PRIZE */ .Kx0.PRIZE,
        name: "시상규모"
    },
    {
        filterType: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.BENEFIT */ .Kx0.BENEFIT,
        name: "수상혜택"
    },
    {
        filterType: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.TARGET */ .Kx0.TARGET,
        name: "응모대상"
    },
    {
        filterType: generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.ORGANIZATION */ .Kx0.ORGANIZATION,
        name: "주최기관"
    }, 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT, []), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.INTERN */ .kF.INTERN, []), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION, []), _obj);
var _obj1;
var fieldNameByActivityFilterType = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.CATEGORY */ .Kx0.CATEGORY, "categoryIDs"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.INTEREST */ .Kx0.INTEREST, "interestIDs"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.PERIOD */ .Kx0.PERIOD, "period"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.REGION */ .Kx0.REGION, "regionIDs"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.BENEFIT */ .Kx0.BENEFIT, "benefitIDs"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.ORGANIZATION */ .Kx0.ORGANIZATION, "organizationTypes"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.PRIZE */ .Kx0.PRIZE, "reward"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityFilterType.TARGET */ .Kx0.TARGET, "targetIDs"), _obj1);
var PAGE_SIZE = 20;


/***/ }),

/***/ 28098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DutyModal_DutyModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.components/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(7029);
// EXTERNAL MODULE: ./src/svgIcons/CloseOutlined.tsx
var CloseOutlined = __webpack_require__(57065);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.components/Pagination/Pagination.tsx
var Pagination = __webpack_require__(56081);
// EXTERNAL MODULE: ./src/app.feature/coverletter/coverletter.write/styles/index.ts + 1 modules
var styles = __webpack_require__(8300);
// EXTERNAL MODULE: ./src/components/BounceLoading.tsx
var BounceLoading = __webpack_require__(14609);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(64529);
// EXTERNAL MODULE: ./src/app.feature/coverletter/coverletter.write/module/constant/index.ts
var constant = __webpack_require__(83453);
;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/store/dutyModal.ts





var initialVariables = {
    orderBy: {
        field: graphql/* DutyOrderField.SELF_INTRODUCTION_COUNT */.Dvz.SELF_INTRODUCTION_COUNT,
        direction: graphql/* OrderDirection.DESC */.N9t.DESC
    },
    filterBy: {
        hasQuestionTemplate: true,
        ignoreEndedActivity: true
    },
    pagination: {
        page: 1,
        pageSize: constant/* PAGE_SIZE */.IV
    }
};
var useDutyModalStore = (0,esm/* default */.ZP)(function(set) {
    return {
        closeModal: function() {},
        setCloseModal: function(closeModal) {
            set(function(store) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, store), {
                    closeModal: closeModal
                });
            });
        },
        variables: initialVariables,
        setVariables: function(variables) {
            set(function(store) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, store), {
                    variables: variables
                });
            });
        },
        resetVariables: function() {
            set(function(store) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, store), {
                    variables: initialVariables
                });
            });
        }
    };
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/app.components/Avatar/Avatar.tsx
var Avatar = __webpack_require__(57315);
// EXTERNAL MODULE: ./src/app.components/Button/index.tsx
var Button = __webpack_require__(85025);
// EXTERNAL MODULE: ./src/app.feature/coverletter/coverletter.write/hook/useDuplicateSelfIntroduction.tsx
var useDuplicateSelfIntroduction = __webpack_require__(54487);
// EXTERNAL MODULE: ./src/app.modules/util/time.tsx
var time = __webpack_require__(20178);
// EXTERNAL MODULE: ./src/svgIcons/MagnifyingGlass.tsx
var MagnifyingGlass = __webpack_require__(8741);
// EXTERNAL MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/DutyList/QuestionList.tsx
var QuestionList = __webpack_require__(5111);
;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/DutyList/DutyItem.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment DutyItem_Duty on Duty {\n    id\n    title\n    jobType\n    selfIntroductionCount\n    categories {\n      id\n      name\n    }\n    questionTemplates {\n      id\n      charSize\n      charMaxSize\n      blankType\n      content\n    }\n    activity {\n      id\n      logoImage {\n        id\n        url\n      }\n      organizationName\n      title\n      recruitType\n      recruitCloseAt\n    }\n    ...useDuplicateSelfIntroduction_Duty\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid #eeeeee;\n  display: flex;\n  height: 60px;\n  align-items: center;\n  font-size: 14px;\n  width: 100%;\n\n  .company-name-wrapper {\n    display: flex;\n    align-items: center;\n    margin-right: 10px;\n    .company-image {\n      width: 36px;\n      height: 36px;\n      margin-right: 10px;\n    }\n    .company-name {\n      font-size: 12px;\n      width: 119px;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      font-weight: bold;\n    }\n  }\n\n  .duty-name {\n    color: #333333;\n    width: 290px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    font-size: 14px;\n    font-weight: 400;\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n  .deadline {\n    width: 75px;\n    margin-right: 0px;\n    text-align: center;\n  }\n  .write-count {\n    text-align: center;\n    width: 60px;\n    margin-right: 25px;\n  }\n  .job-type {\n    width: 60px;\n    text-align: center;\n  }\n  .question {\n    width: 68px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    .search-icon {\n      width: 32px;\n      height: 32px;\n      border-radius: 50%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: #eeeeee;\n      svg {\n        width: 13px;\n        height: 13px;\n      }\n    }\n    .question-list {\n      display: none;\n      position: absolute;\n      z-index: 1;\n      top: -10px;\n      right: 100%;\n      padding: 0 0px 0px 0;\n    }\n    &:hover {\n      .search-icon {\n        background-color: #f2faff;\n        svg {\n          path {\n            fill: #01a0ff;\n          }\n        }\n      }\n      .question-list {\n        display: block;\n      }\n    }\n    &[data-active='true'] {\n      .question-list {\n        top: -10px;\n        bottom: inherit;\n      }\n    }\n  }\n  .activity-link {\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    padding-right: 20px;\n    .right-icon {\n      display: flex;\n      align-items: center;\n      margin-top: 3px;\n      width: 9px;\n      height: 9px;\n    }\n  }\n\n  &:nth-last-child(1),\n  &:nth-last-child(2) {\n    .question-list {\n      top: inherit;\n      bottom: -10px;\n    }\n  }\n  &:hover {\n    background-color: #fafafa;\n  }\n\n  .create-button {\n    cursor: pointer;\n    width: 82px;\n    font-weight: 600;\n    height: 40px;\n    font-size: 12px;\n    /* padding: 12px 20px; */\n  }\n\n  .avatar {\n    border-radius: 5px;\n    border: 1px solid #dddddd;\n    & img {\n      object-fit: contain;\n      background-color: #fff;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












src_default()(_templateObject());
var DutyItem = function(param) {
    var data = param.data, length = param.length;
    var ref, ref1, ref2, ref3, ref4;
    var closeModal = useDutyModalStore(function(store) {
        return store.closeModal;
    });
    var duplicateSelfIntroduction = (0,useDuplicateSelfIntroduction/* default */.Z)(data, closeModal);
    var openRecruitPage = function() {
        if (!data.activity || !window) return;
        window.open("/activity/".concat(data.activity.id));
    };
    var jobType = (0,utils/* jobTypeToString */.FC)(data.jobType) || "-";
    var createSelfIntroduction = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            duplicateSelfIntroduction()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function createSelfIntroduction() {
            return _ref.apply(this, arguments);
        };
    }();
    // TODO: 레거시 코드라 내부 코드 자체를 수정하게되면 사이드 이슈가 발생할 수 있어 플래그 추가방식으로 수정
    // 개선 필요합니다
    var remainingTime = (0,time/* formatRemainingTimeToString */.ax)(((ref = data.activity) === null || ref === void 0 ? void 0 : ref.recruitCloseAt) || undefined, (ref1 = data.activity) === null || ref1 === void 0 ? void 0 : ref1.recruitType, "DutyItem", true);
    var writeCount = "".concat(data.selfIntroductionCount, "명");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "company-name-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "company-image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            src: "".concat((ref2 = data.activity) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.logoImage) === null || ref3 === void 0 ? void 0 : ref3.url, "?d=autox34"),
                            className: "avatar"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "company-name",
                        children: (ref4 = data.activity) === null || ref4 === void 0 ? void 0 : ref4.organizationName
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "duty-name",
                onClick: openRecruitPage,
                children: data.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "job-type",
                children: jobType
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "deadline",
                children: remainingTime
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "question",
                "data-active": length < 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "search-icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MagnifyingGlass/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionList/* default */.Z, {
                        className: "question-list",
                        data: data.questionTemplates || []
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "write-count",
                children: writeCount
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "create-button",
                variant: "outlined",
                color: "primary",
                onClick: createSelfIntroduction,
                children: "작성하기"
            })
        ]
    });
};
/* harmony default export */ var DutyList_DutyItem = (DutyItem);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DutyItem__StyledWrapper",
    componentId: "sc-ec7a4c28-0"
})(_templateObject1());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./src/app.modules/hooks/useDropdown.tsx
var useDropdown = __webpack_require__(6714);
;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/DutyList/DutyListHeader/CategoryDropdown.tsx



function CategoryDropdown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query gqlCategoryDropdown($filterBy: CategoryFilter) {\n    categories(filterBy: $filterBy) {\n      id\n      name\n    }\n  }\n"
    ]);
    CategoryDropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CategoryDropdown_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px 0;\n  width: 120px;\n  position: absolute;\n  top: calc(100% + 5px);\n  left: calc(50% - 7px);\n  transform: translateX(-50%);\n  background-color: white;\n  border: 1px solid #cccccc;\n  z-index: 10;\n  border-radius: 5px;\n  cursor: pointer;\n  .dropdown-item {\n    padding: 8px 16px;\n    color: #333333;\n    font-size: 12px;\n    height: 32px;\n    text-align: start;\n    &:hover {\n      background-color: #f8f8f8;\n    }\n  }\n"
    ]);
    CategoryDropdown_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







src_default()(CategoryDropdown_templateObject());
var CategoryDropdown = function() {
    var data = (0,graphql/* useGqlCategoryDropdownQuery */.hS5)({
        variables: {
            filterBy: {
                activityType: graphql/* CategoryActivityType.RECRUIT */.YMW.RECRUIT,
                parentId: null
            }
        }
    }).data;
    var variables = useDutyModalStore(function(store) {
        return store.variables;
    });
    var setVariables = useDutyModalStore(function(store) {
        return store.setVariables;
    });
    var handleAllItemClick = function() {
        setVariables((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables), {
            filterBy: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables === null || variables === void 0 ? void 0 : variables.filterBy), {
                categoryId: undefined
            }),
            pagination: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables === null || variables === void 0 ? void 0 : variables.pagination), {
                page: 1,
                pageSize: constant/* PAGE_SIZE */.IV
            })
        }));
    };
    var handleCategoryClick = function(categoryId) {
        setVariables((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables), {
            filterBy: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables === null || variables === void 0 ? void 0 : variables.filterBy), {
                categoryId: categoryId
            }),
            pagination: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables === null || variables === void 0 ? void 0 : variables.pagination), {
                page: 1,
                pageSize: constant/* PAGE_SIZE */.IV
            })
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryDropdown_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "dropdown-item",
                onClick: handleAllItemClick,
                children: "전체"
            }),
            function() {
                if (!(data === null || data === void 0 ? void 0 : data.categories)) return null;
                return data.categories.map(function(category) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "dropdown-item",
                        onClick: function() {
                            return handleCategoryClick(category.id);
                        },
                        children: category.name
                    }, "CategoryDropdown-".concat(category.id));
                });
            }()
        ]
    });
};
/* harmony default export */ var DutyListHeader_CategoryDropdown = (CategoryDropdown);
var CategoryDropdown_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategoryDropdown__StyledWrapper",
    componentId: "sc-21f8d1c-0"
})(CategoryDropdown_templateObject1());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/DutyList/DutyListHeader/JobTypeDropdown.tsx




function JobTypeDropdown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px 0;\n  width: 115px;\n  position: absolute;\n  top: calc(100% + 5px);\n  left: calc(50% - 7px);\n  transform: translateX(-50%);\n  background-color: white;\n  border: 1px solid #cccccc;\n  z-index: 10;\n  border-radius: 5px;\n  cursor: pointer;\n  .dropdown-item {\n    padding: 8px 16px;\n    color: #333333;\n    font-size: 12px;\n    height: 32px;\n    text-align: start;\n    &:hover {\n      background-color: #f8f8f8;\n    }\n  }\n"
    ]);
    JobTypeDropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var _obj;
var formatJobType = (_obj = {}, (0,_define_property/* default */.Z)(_obj, graphql/* JobType.NEW */.O4l.NEW, "신입"), (0,_define_property/* default */.Z)(_obj, graphql/* JobType.INTERN */.O4l.INTERN, "인턴"), (0,_define_property/* default */.Z)(_obj, graphql/* JobType.EXPERIENCED */.O4l.EXPERIENCED, "경력"), (0,_define_property/* default */.Z)(_obj, graphql/* JobType.CONTRACT */.O4l.CONTRACT, "계약"), _obj);
var JobTypeDropdown = function() {
    var variables = useDutyModalStore(function(store) {
        return store.variables;
    });
    var setVariables = useDutyModalStore(function(store) {
        return store.setVariables;
    });
    var handleAllItemClick = function() {
        setVariables((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables), {
            filterBy: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables === null || variables === void 0 ? void 0 : variables.filterBy), {
                jobType: undefined
            }),
            pagination: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables === null || variables === void 0 ? void 0 : variables.pagination), {
                page: 1,
                pageSize: constant/* PAGE_SIZE */.IV
            })
        }));
    };
    var handleJobTypeItemClick = function(key) {
        setVariables((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables), {
            filterBy: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables === null || variables === void 0 ? void 0 : variables.filterBy), {
                jobType: key
            }),
            pagination: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables === null || variables === void 0 ? void 0 : variables.pagination), {
                page: 1,
                pageSize: constant/* PAGE_SIZE */.IV
            })
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobTypeDropdown_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "dropdown-item",
                onClick: handleAllItemClick,
                children: "전체"
            }),
            Object.keys(formatJobType).map(function(key, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "dropdown-item",
                    onClick: function() {
                        return handleJobTypeItemClick(key);
                    },
                    children: formatJobType[key]
                }, "dropdown-item-".concat(index));
            })
        ]
    });
};
/* harmony default export */ var DutyListHeader_JobTypeDropdown = (JobTypeDropdown);
var JobTypeDropdown_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "JobTypeDropdown__StyledWrapper",
    componentId: "sc-2f664211-0"
})(JobTypeDropdown_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/DutyList/DutyListHeader/DutyListHeader.tsx


function DutyListHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  color: #333333;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  border-top: 1px solid #e8e8e8;\n  border-bottom: 1px solid #e8e8e8;\n  height: 40px;\n  text-align: center;\n\n  .dropdown-btn {\n    cursor: pointer;\n    display: flex;\n    gap: 7px;\n    justify-content: center;\n    align-items: center;\n    .filter-icon {\n      width: 10px;\n      height: 10px;\n      margin-top: 1px;\n    }\n  }\n"
    ]);
    DutyListHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DutyListHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex-basis: ",
        "%;\n"
    ]);
    DutyListHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var DutyListHeader = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useDropdown/* default */.Z)(), 3), categoryRef = ref[0], categoryOpen = ref[1], toggleCategory = ref[2];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useDropdown/* default */.Z)(), 3), jobTypeRef = ref1[0], jobTypeOpen = ref1[1], toggleJobType = ref1[2];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DutyListHeader_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderTitle, {
                basis: 20,
                children: "기업명"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderTitle, {
                basis: 34,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "dropdown-btn",
                        ref: categoryRef,
                        onClick: toggleCategory,
                        children: [
                            "직무",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ExpandMore */.pb, {
                                className: "filter-icon",
                                fontSize: "inherit"
                            })
                        ]
                    }),
                    categoryOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(DutyListHeader_CategoryDropdown, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderTitle, {
                basis: 7,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "dropdown-btn",
                        ref: jobTypeRef,
                        onClick: toggleJobType,
                        children: [
                            "형태",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ExpandMore */.pb, {
                                className: "filter-icon",
                                fontSize: "inherit"
                            })
                        ]
                    }),
                    jobTypeOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(DutyListHeader_JobTypeDropdown, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderTitle, {
                basis: 9,
                children: "마감일"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderTitle, {
                basis: 8,
                className: "question",
                children: "문항"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderTitle, {
                basis: 7,
                children: "작성자 수"
            })
        ]
    });
};
/* harmony default export */ var DutyListHeader_DutyListHeader = (DutyListHeader);
var DutyListHeader_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DutyListHeader__StyledWrapper",
    componentId: "sc-5ece2603-0"
})(DutyListHeader_templateObject());
var StyledHeaderTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DutyListHeader__StyledHeaderTitle",
    componentId: "sc-5ece2603-1"
})(DutyListHeader_templateObject1(), function(param) {
    var basis = param.basis;
    return basis;
});

;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/DutyList/SearchResultNotFound.tsx

function SearchResultNotFound_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* width: 100%; */\n  /* height: 100%; */\n  margin: auto;\n  padding: 200px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  text-align: center;\n  .not-found-message {\n    color: #333333;\n    font-weight: 500;\n    font-size: 20px;\n    margin-bottom: 10px;\n  }\n  .not-found-keyword {\n    color: #999999;\n    font-weight: 500;\n  }\n  .search-tip {\n    font-size: 16px;\n    color: #999999;\n  }\n"
    ]);
    SearchResultNotFound_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var SearchResultNotFound = function() {
    var ref, ref1;
    var variables = useDutyModalStore(function(store) {
        return store.variables;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchResultNotFound_StyledWrapper, {
        children: [
            (variables === null || variables === void 0 ? void 0 : (ref = variables.filterBy) === null || ref === void 0 ? void 0 : ref.query) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                        className: "not-found-message",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    color: "#01a0ff"
                                },
                                children: variables.filterBy.query
                            }),
                            " ",
                            "에 대한 검색결과가 없습니다."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "search-tip",
                        children: [
                            "단어의 철자가 정확한지 확인하세요.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " 다른 검색어를 사용해보세요.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " 더 일반적인 검색어를 사용해 보세요."
                        ]
                    })
                ]
            }),
            !(variables === null || variables === void 0 ? void 0 : (ref1 = variables.filterBy) === null || ref1 === void 0 ? void 0 : ref1.query) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "not-found-keyword",
                children: "등록된 공고가 없습니다."
            })
        ]
    });
};
/* harmony default export */ var DutyList_SearchResultNotFound = (SearchResultNotFound);
var SearchResultNotFound_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SearchResultNotFound__StyledWrapper",
    componentId: "sc-677b0cd3-0"
})(SearchResultNotFound_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/DutyList/DutyList.tsx



function DutyList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query gqlDutyList(\n    $orderBy: DutyOrder\n    $filterBy: DutyFilters\n    $pagination: Pagination\n  ) {\n    duties(orderBy: $orderBy, filterBy: $filterBy, pagination: $pagination) {\n      nodes {\n        ...DutyItem_Duty\n      }\n      totalCount\n    }\n  }\n"
    ]);
    DutyList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DutyList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  >.list-wrapper {\n    position: relative;\n    overflow: auto;\n\n    height: 550px;\n    ",
        "\n  }\n  .root-loading-wrapper {\n    height: 550px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    .loading {\n      margin-bottom: 30px;\n    }\n    .loading-text {\n      font-size: 14px;\n      font-weight: 500;\n      color: #999999;\n      text-align: center;\n    }\n  }\n  .pagination-wrapper {\n    padding-top: 20px;\n  }\n"
    ]);
    DutyList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












src_default()(DutyList_templateObject());
var DutyList = function() {
    var ref, ref1;
    var variables = useDutyModalStore(function(store) {
        return store.variables;
    });
    var setVariables = useDutyModalStore(function(store) {
        return store.setVariables;
    });
    var ref2 = (0,graphql/* useGqlDutyListQuery */.UBb)({
        variables: variables,
        fetchPolicy: "cache-and-network"
    }), data = ref2.data, loading = ref2.loading, error = ref2.error;
    var handleChange = function(page) {
        if (!variables || !variables.pagination) return;
        setVariables((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables), {
            pagination: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables.pagination), {
                page: page
            })
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DutyList_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DutyListHeader_DutyListHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "list-wrapper",
                children: function() {
                    // * Loading
                    if (loading || error || !(data === null || data === void 0 ? void 0 : data.duties.nodes)) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "root-loading-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BounceLoading/* default */.Z, {
                                className: "loading"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "loading-text",
                                children: "공고를 불러오고 있습니다."
                            })
                        ]
                    });
                    // * Empty
                    if (data.duties.nodes.length === 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(DutyList_SearchResultNotFound, {});
                    return data.duties.nodes.filter(function(node) {
                        return node !== null;
                    }).map(function(node) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DutyList_DutyItem, {
                            data: node,
                            length: data.duties.nodes.length
                        }, "RecruitList-".concat(node.id));
                    });
                }()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pagination-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                    type: "value",
                    stepSize: 10,
                    totalCount: data === null || data === void 0 ? void 0 : data.duties.totalCount,
                    pageSize: variables === null || variables === void 0 ? void 0 : (ref = variables.pagination) === null || ref === void 0 ? void 0 : ref.pageSize,
                    value: loading ? 1 : variables === null || variables === void 0 ? void 0 : (ref1 = variables.pagination) === null || ref1 === void 0 ? void 0 : ref1.page,
                    onChange: handleChange,
                    isDisabled: loading
                })
            })
        ]
    });
};
/* harmony default export */ var DutyList_DutyList = (DutyList);
var DutyList_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DutyList__StyledWrapper",
    componentId: "sc-f5ce3676-0"
})(DutyList_templateObject1(), styles/* NoDragTextSelectionCss */.O, styles/* CustomScrollBarCss */.F);

;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/DutyList/index.ts


// EXTERNAL MODULE: ./src/app.components/modals/AlertModal/index.ts + 1 modules
var AlertModal = __webpack_require__(56769);
;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/TableActions/ActivitySearch/ActivitySearch.tsx



function ActivitySearch_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  width: 250px;\n  height: 40px;\n  padding: 0px 15px;\n  border-radius: 8px;\n  border: solid 1px #dddddd;\n\n  > input {\n    width: 250px;\n    height: 100%;\n    border: none;\n    outline: none;\n    &::placeholder {\n      font-size: 14px;\n      font-weight: 500;\n      letter-spacing: -0.56px;\n      color: #999999;\n    }\n  }\n\n  .search-icon {\n    width: 18px;\n    right: 16px;\n  }\n"
    ]);
    ActivitySearch_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ActivitySearch = function() {
    var ref;
    var variables = useDutyModalStore(function(store) {
        return store.variables;
    });
    var setVariables = useDutyModalStore(function(store) {
        return store.setVariables;
    });
    var ref1 = (0,react.useState)(""), input = ref1[0], setInput = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        if ((variables === null || variables === void 0 ? void 0 : (ref = variables.filterBy) === null || ref === void 0 ? void 0 : ref.query) === "") setInput("");
    }, [
        variables === null || variables === void 0 ? void 0 : (ref = variables.filterBy) === null || ref === void 0 ? void 0 : ref.query
    ]);
    var handleSubmit = function(e) {
        e.preventDefault();
        if (input && input.trim().length < 2) {
            (0,AlertModal/* openAlertModal */.N)({
                open: true,
                message: "검색어는 2자 이상 입력하셔야합니다.",
                isModalOverlapping: true
            });
            return;
        }
        setVariables((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables), {
            filterBy: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables === null || variables === void 0 ? void 0 : variables.filterBy), {
                query: input
            }),
            pagination: {
                page: 1,
                pageSize: constant/* PAGE_SIZE */.IV
            }
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActivitySearch_StyledWrapper, {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MagnifyingGlass/* default */.Z, {
                className: "search-icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                placeholder: "회사 또는 직무를 검색하세요",
                value: input,
                onChange: function(e) {
                    return setInput(e.target.value);
                }
            })
        ]
    });
};
/* harmony default export */ var ActivitySearch_ActivitySearch = (ActivitySearch);
var ActivitySearch_StyledWrapper = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    displayName: "ActivitySearch__StyledWrapper",
    componentId: "sc-2e8e7e56-0"
})(ActivitySearch_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/TableActions/ActivitySearch/index.ts


;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/TableActions/BackButton.tsx



function BackButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .back-button {\n    font-size: 12px;\n    padding: 6px 18px;\n  }\n"
    ]);
    BackButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var BackButton = function() {
    var variables = useDutyModalStore(function(store) {
        return store.variables;
    });
    var setVariables = useDutyModalStore(function(store) {
        return store.setVariables;
    });
    var handleClick = function() {
        if (!(variables === null || variables === void 0 ? void 0 : variables.filterBy)) return;
        setVariables((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables), {
            filterBy: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables.filterBy), {
                query: ""
            })
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            className: "back-button",
            onClick: handleClick,
            children: "목록으로 돌아가기"
        })
    });
};
/* harmony default export */ var TableActions_BackButton = (BackButton);
var BackButton_StyledWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "BackButton__StyledWrapper",
    componentId: "sc-81d90a8-0"
})(BackButton_templateObject());

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/app.feature/coverletter/coverletter.write/hook/useLoadSelfIntroduction.ts + 2 modules
var useLoadSelfIntroduction = __webpack_require__(22605);
// EXTERNAL MODULE: ./src/svgIcons/CoverLetterWrite.tsx
var CoverLetterWrite = __webpack_require__(57443);
;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/TableActions/CreateButton/CreateButton.tsx

function CreateButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .create-button {\n    width: 150px;\n    font-size: 12px;\n    font-weight: bold;\n    padding: 12px 20px;\n  }\n"
    ]);
    CreateButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var CreateButton = function() {
    var query = (0,router.useRouter)().query;
    var loadSelfIntroduction = (0,useLoadSelfIntroduction/* default */.Z)({
        openNewTab: true
    });
    var closeModal = useDutyModalStore(function(store) {
        return store.closeModal;
    });
    var selectedStatus = query.selfIntroductionStatus;
    var handleCreateButtonClick = function() {
        loadSelfIntroduction({
            callback: function() {
                return closeModal();
            },
            variables: {
                input: {
                    title: "새 자기소개서",
                    selfIntroductionInfoInput: selectedStatus ? {
                        status: selectedStatus
                    } : undefined,
                    qnas: [
                        {
                            question: "",
                            answer: "",
                            charMaxSize: 1000
                        }, 
                    ]
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateButton_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverLetterWrite/* default */.Z, {}),
            className: "create-button",
            onClick: handleCreateButtonClick,
            children: "새 자소서 작성"
        })
    });
};
/* harmony default export */ var CreateButton_CreateButton = (CreateButton);
var CreateButton_StyledWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CreateButton__StyledWrapper",
    componentId: "sc-6fae286d-0"
})(CreateButton_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/TableActions/CreateButton/index.tsx

/* harmony default export */ var TableActions_CreateButton = (CreateButton_CreateButton);

// EXTERNAL MODULE: ./src/app.feature/activityList/constants/constant.ts
var constants_constant = __webpack_require__(10572);
// EXTERNAL MODULE: ./src/svgIcons/ExpandMore.tsx
var ExpandMore = __webpack_require__(40934);
;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/TableActions/activityFilter/filterSelect/SelectBox.tsx

function SelectBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 40px;\n    padding: 13px 10px 13px 15px;\n    border-radius: 8px;\n    border: solid 1px ",
        ";\n    background-color: ",
        ";\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    user-select: none;\n\n    &[data-focused='true'] {\n      border: solid 1px ",
        ";\n    }\n\n    & > p {\n      height: 24px;\n      font-size: 16px;\n      line-height: 24px;\n      letter-spacing: -0.64px;\n      text-align: left;\n    }\n\n    & > p {\n      font-weight: 500;\n      color: ",
        ";\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 5px;\n    }\n\n    & > i {\n      width: 24px;\n      height: 24px;\n      text-align: center;\n    }\n  "
    ]);
    SelectBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SelectBox_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    SelectBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SelectBox = function(param) {
    var selectValue = param.selectValue, isFocused = param.isFocused, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, onClick = param.onClick;
    var handleClick = function(e) {
        e.stopPropagation();
        if (!disabled) {
            onClick();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectBox_StyledWrapper, {
        onClick: handleClick,
        "data-focused": isFocused,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: selectValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "icon-arrow",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var filterSelect_SelectBox = (SelectBox);
var SelectBox_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelectBox__StyledWrapper",
    componentId: "sc-1cd1575f-0"
})(SelectBox_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(SelectBox_templateObject(), theme.line.line_2, theme.background.bg_8, theme.color.primary_2, theme.color.text_1);
});

;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/TableActions/activityFilter/filterSelect/SelectOption.tsx

function SelectOption_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: fit-content;\n    max-height: 320px;\n    overflow-y: auto;\n    border: solid 1px ",
        ";\n    border-radius: 8px;\n    background-color: ",
        ";\n    position: absolute;\n    left: 0;\n    top: 44px;\n    z-index: 10;\n\n    & > li {\n      height: 40px;\n      display: flex;\n      align-items: center;\n      padding: 10px 15px;\n\n      &:hover {\n        background-color: ",
        ";\n      }\n\n      p {\n        height: 20px;\n        font-size: 14px;\n        font-weight: normal;\n        line-height: 20px;\n        letter-spacing: -0.56px;\n        text-align: left;\n        color: ",
        ";\n\n        &:not(:first-child) {\n          margin-left: 5px;\n        }\n      }\n    }\n  "
    ]);
    SelectOption_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SelectOption_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    SelectOption_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var SelectOption = function(param) {
    var options = param.options, onClick = param.onClick;
    var handleClick = function(e) {
        onClick({
            value: e.currentTarget.dataset.selectValue,
            label: e.currentTarget.dataset.selectLabel || ""
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOption_StyledWrapper, {
        children: options.map(function(option) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                onClick: handleClick,
                "data-select-value": option.value,
                "data-select-label": option.label,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: option.label
                })
            }, "option-id-".concat(option.value));
        })
    });
};
/* harmony default export */ var filterSelect_SelectOption = (SelectOption);
var SelectOption_StyledWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "SelectOption__StyledWrapper",
    componentId: "sc-14edbb01-0"
})(SelectOption_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(SelectOption_templateObject(), theme.line.line_1, theme.background.bg_8, theme.background.bg_3, theme.color.text_1);
});

;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/TableActions/activityFilter/ActivityFilter.tsx



function ActivityFilter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  cursor: pointer;\n  width: 140px;\n\n  > div > p {\n    font-size: 14px;\n    margin: 0px !important;\n  }\n  > ul {\n    margin: 0px !important;\n    height: max-content;\n  }\n"
    ]);
    ActivityFilter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ACTIVITY_OPTIONS = [
    {
        label: "인기순",
        value: graphql/* DutyOrderField.SELF_INTRODUCTION_COUNT */.Dvz.SELF_INTRODUCTION_COUNT
    },
    {
        label: "공고 마감일 순",
        value: graphql/* DutyOrderField.END_AT */.Dvz.END_AT
    },
    {
        label: "최신순",
        value: graphql/* DutyOrderField.JOB_TYPE_CREATED_AT */.Dvz.JOB_TYPE_CREATED_AT
    }, 
];
var ActivityFilter = function() {
    var ref = (0,react.useState)(ACTIVITY_OPTIONS[0]), selectedOption = ref[0], setSelectedOption = ref[1];
    var ref1 = (0,react.useState)(false), isShowOptions = ref1[0], setIsShowOptions = ref1[1];
    var variables = useDutyModalStore(function(store) {
        return store.variables;
    });
    var setVariables = useDutyModalStore(function(store) {
        return store.setVariables;
    });
    var handleToggleOptions = function() {
        setIsShowOptions(function(prev) {
            return !prev;
        });
    };
    var handleChangeSelectedValue = function(option) {
        setIsShowOptions(false);
        var direction = option.value === graphql/* DutyOrderField.END_AT */.Dvz.END_AT ? graphql/* OrderDirection.ASC */.N9t.ASC : graphql/* OrderDirection.DESC */.N9t.DESC;
        setVariables((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables), {
            filterBy: (0,_object_spread/* default */.Z)({}, variables === null || variables === void 0 ? void 0 : variables.filterBy),
            orderBy: {
                field: option.value,
                direction: direction
            },
            pagination: {
                page: 1,
                pageSize: constants_constant/* PAGE_SIZE */.IV
            }
        }));
        setSelectedOption(option);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActivityFilter_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(filterSelect_SelectBox, {
                selectValue: selectedOption.label,
                onClick: handleToggleOptions,
                isFocused: isShowOptions
            }),
            isShowOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)(filterSelect_SelectOption, {
                options: ACTIVITY_OPTIONS,
                onClick: handleChangeSelectedValue
            })
        ]
    });
};
/* harmony default export */ var activityFilter_ActivityFilter = (ActivityFilter);
var ActivityFilter_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ActivityFilter__StyledWrapper",
    componentId: "sc-bb96d56d-0"
})(ActivityFilter_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/TableActions/TableActions.tsx

function TableActions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 40px;\n  margin-bottom: 8px;\n\n  > .right-section {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  & * {\n    height: inherit;\n  }\n"
    ]);
    TableActions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var TableActions = function() {
    var query = useDutyModalStore(function(store) {
        var ref, ref1;
        return (ref = store.variables) === null || ref === void 0 ? void 0 : (ref1 = ref.filterBy) === null || ref1 === void 0 ? void 0 : ref1.query;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableActions_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivitySearch_ActivitySearch, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "right-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(activityFilter_ActivityFilter, {}),
                    query ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TableActions_BackButton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TableActions_CreateButton, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var TableActions_TableActions = (TableActions);
var TableActions_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TableActions__StyledWrapper",
    componentId: "sc-daedc383-0"
})(TableActions_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/components/TableActions/index.tsx

/* harmony default export */ var components_TableActions = (TableActions_TableActions);

;// CONCATENATED MODULE: ./src/app.feature/coverletter/coverletter.write/screen/Toolbar/DutyModal/DutyModal.tsx

function DutyModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  .modal-wrapper {\n    position: relative;\n    border-radius: 20px;\n    background-color: white;\n    padding: 30px;\n    width: 920px;\n    .close-btn {\n      z-index: 2;\n      cursor: pointer;\n      position: absolute;\n      top: 30px;\n      color: #999999;\n      right: 30px;\n\n      svg {\n        width: 30px;\n        height: 30px;\n      }\n    }\n    .modal-title {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 24px;\n      font-weight: 600;\n      margin-top: 0;\n      margin-bottom: 36px;\n    }\n  }\n"
    ]);
    DutyModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var DutyModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var setCloseModal = useDutyModalStore(function(store) {
        return store.setCloseModal;
    });
    var resetVariables = useDutyModalStore(function(store) {
        return store.resetVariables;
    });
    setCloseModal(onClose);
    (0,react.useEffect)(function() {
        return function() {
            resetVariables();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DutyModal_StyledWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "close-btn",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "modal-title",
                        children: "공고 선택하기"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TableActions, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DutyList_DutyList, {})
                ]
            })
        })
    });
};
/* harmony default export */ var DutyModal_DutyModal = (DutyModal);
var DutyModal_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DutyModal__StyledWrapper",
    componentId: "sc-cab26ec9-0"
})(DutyModal_templateObject());


/***/ }),

/***/ 1945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _DutyModal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28098);

/* harmony default export */ __webpack_exports__["Z"] = (_DutyModal__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 20178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ui": function() { return /* binding */ convertCreatedAtToString; },
/* harmony export */   "ax": function() { return /* binding */ formatRemainingTimeToString; }
/* harmony export */ });
/* unused harmony export getRemainingTime */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var date_fns_differenceInDays__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23311);
/* harmony import */ var date_fns_differenceInHours__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76972);
/* harmony import */ var date_fns_differenceInMinutes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69690);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32912);
/* harmony import */ var date_fns_isAfter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42699);
/* harmony import */ var date_fns_subDays__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7069);
/* harmony import */ var date_fns_subHours__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81289);
/* harmony import */ var date_fns_subMinutes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88619);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47079);










var convertCreatedAtToString = function(createdAt) {
    var NOW = new Date();
    var ONE_MINUTE_AGO = (0,date_fns_subMinutes__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(NOW, 1);
    var ONE_HOUR_AGO = (0,date_fns_subHours__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(NOW, 1);
    var ONE_DAY_AGO = (0,date_fns_subHours__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(NOW, 24);
    var ONE_WEEK_AGO = (0,date_fns_subDays__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(NOW, 7);
    var writenInOneMunite = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(createdAt, ONE_MINUTE_AGO);
    var writenInOneHour = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(createdAt, ONE_HOUR_AGO);
    var writenInOneDay = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(createdAt, ONE_DAY_AGO);
    var writenInOneWeek = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(createdAt, ONE_WEEK_AGO);
    if (writenInOneMunite) {
        return "방금 전";
    }
    if (writenInOneHour) {
        return "".concat((0,date_fns_differenceInMinutes__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(NOW, createdAt), "분 전");
    }
    if (writenInOneDay) {
        return "".concat((0,date_fns_differenceInHours__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(NOW, createdAt), "시간 전");
    }
    if (writenInOneWeek) {
        return "".concat((0,date_fns_differenceInDays__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(NOW, createdAt), "일 전");
    }
    return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(createdAt, "yyyy.MM.dd");
};
var getRemainingTime = function(date) {
    var nowDate = new Date();
    return (0,date_fns_differenceInDays__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(date, nowDate.getTime());
};
var formatRemainingTimeToString = function(closedAt, recruitType) {
    var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "CoverLetterTitle", isOnlyDate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    switch(recruitType){
        case generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ActivityRecruitType.ALWAYS */ .iS2.ALWAYS:
            return "상시채용";
        case generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ActivityRecruitType.ASAP */ .iS2.ASAP:
            return "채용 시 마감";
        case generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ActivityRecruitType.SCHEDULED */ .iS2.SCHEDULED:
            return "예정";
        case generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .ActivityRecruitType.NORMAL */ .iS2.NORMAL:
            if (closedAt) {
                var dDay = getRemainingTime(closedAt);
                if (dDay === 0) {
                    var hours = (0,date_fns_differenceInHours__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(closedAt, new Date());
                    if (hours === 0) {
                        var minutes = (0,date_fns_differenceInMinutes__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(closedAt, new Date());
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            style: {
                                color: "#ff0000"
                            },
                            children: [
                                minutes,
                                "분 남음"
                            ]
                        });
                    }
                    if (hours < 0) {
                        if (type === "DutyItem") return "마감";
                        return "D+".concat(Math.abs(hours), "시");
                    }
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        style: {
                            color: "#ff0000"
                        },
                        children: [
                            hours,
                            "시간 남음"
                        ]
                    });
                }
                if (dDay < 0) {
                    if (type === "DutyItem") return "마감";
                    return "D+".concat(Math.abs(dDay) > 999 ? 999 : Math.abs(dDay)).concat(isOnlyDate ? "" : "일");
                }
                return "D-".concat(dDay > 999 ? 999 : dDay).concat(isOnlyDate ? "" : "일");
            }
            return "마감일 없음";
        default:
            return "마감일 없음";
    }
};


/***/ }),

/***/ 65155:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    INVALID_REQUEST: "올바르지 않은 요청 입니다.",
    NO_RESPONSE_ERROR: "현재 서버에 응답이 없습니다. 잠시후 다시 시도해주세요",
    UNKNOWN_ERROR: "알 수 없는 오류가 발생했습니다.",
    FORBIDDEN: "요청할 수 있는 권한이 없습니다.",
    UNAUTHENTICATED: "계정이 인증되지 않았습니다. 로그인 확인 후 다시 시도해 보세요.",
    REQUIRED_LOGGED_IN: "로그인 후 사용할 수 있습니다.",
    NOT_FOUND_ERROR: "알 수 없는 오류가 발생했습니다.",
    ALREADY_EXISTING_EMAIL: "이미 가입된 이메일 입니다. 다른 이메일을 사용해주세요",
    ALREADY_EXISTING_NICKNAME: "이미 가입된 닉네임 입니다. 다른 닉네임을 사용해주세요",
    ALREADY_EXISTING_PHONE_NUMBER: "입력하신 휴대폰 번호는 이미 가입된 회원입니다.",
    INVALID_PHONE_NUMBER_FORMAT: "번호를 올바르게 입력해주세요",
    INVALID_AUTH_CODE: "인증번호가 일치하지 않습니다. 다시 확인해주세요.",
    ALREADY_JOINED_CHAT_ROOM: "이미 참여한 채팅방입니다.",
    TIMESPREAD_STATUS_REQUIRE_PARAMETER: "필요 파리미터 누락",
    TIMESPREAD_STATUS_OBJECT_NOT_EXIST: "일치하는 대상 없음",
    TIMESPREAD_STATUS_PHONE_ALREADY_AUTHORIZE: "이미 인증된 핸드폰 번호입니다.",
    TIMESPREAD_STATUS_PHONE_CODE_REQUEST_EXCEED: "휴대폰 인증 코드 요청 횟수가 초과 하였습니다.",
    TIMESPREAD_STATUS_PHONE_CODE_DATA_NOT_FOUND: "휴대폰 인증 코드 데이터 없음",
    TIMESPREAD_STATUS_PHONE_FAIL_AUTHORIZE: "휴대폰 인증에 실패 하였습니다.",
    TIMESPREAD_STATUS_PHONE_REQUEST_EXCEED: "휴대폰 인증 횟수가 초과 하였습니다.",
    TIMESPREAD_STATUS_PHONE_NOT_ACCEPTED_IP: "허용되지 않은 IP",
    TIMESPREAD_STATUS_PHONE_USER_DELETE: "탈퇴 후 7일 이후부터 휴대폰 인증 가능",
    TIMESPREAD_STATUS_LUCKYBOX_LIMIT_EXCEED: "행운상자 개수 초과",
    TIMESPREAD_STATUS_LUCKYBOX_NEED_CASH: "행운상자 도전 최소 캐시 필요",
    TIMESPREAD_STATUS_LUCKYBOX_ALREADY_OPEN: "이미 오픈된 상자",
    TIMESPREAD_STATUS_SCREEN_ALREADY_FINISH: "이미 종료된 꽉 잠금 모드"
});


/***/ }),

/***/ 96597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29496);
/* harmony import */ var utils_apolloErrorParser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29229);


function useErrorSnackbar() {
    var enqueueApolloError = function enqueueApolloError(error) {
        enqueueSnackbar((0,utils_apolloErrorParser__WEBPACK_IMPORTED_MODULE_1__/* .getErrorMessage */ .e$)(error), {
            // @ts-ignore
            "data-testid": "snackbar-apollo-error",
            // @ts-ignore
            "data-error-code": (0,utils_apolloErrorParser__WEBPACK_IMPORTED_MODULE_1__/* .getErrorCode */ .zg)(error)
        });
    };
    var enqueueErrorMessage = function enqueueErrorMessage(message) {
        enqueueSnackbar(message, {
            // @ts-ignore
            "data-testid": "snackbar-message-error"
        });
    };
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_0__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    return {
        enqueueApolloError: enqueueApolloError,
        enqueueErrorMessage: enqueueErrorMessage
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useErrorSnackbar);


/***/ }),

/***/ 57443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CoverLetterWrite() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        "aria-label": "자소서작성",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("desc", {
                children: "자소서작성"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                "data-name": "그룹 1140",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        fill: "#fff",
                        stroke: "#fff",
                        "data-name": "사각형 1518",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                stroke: "none",
                                d: "M9.264 12.916h6.457v1.211H9.264z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "none",
                                d: "M9.764 13.416h5.457v.211H9.764z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-name": "패스 536",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M11.767 0l-9.65 9.65v4.232h4.23L16 4.234z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#fff",
                                d: "M11.769 2.124l-8.153 8.148v2.11h2.11l8.152-8.149-2.109-2.11m0-2.12L16 4.232l-9.653 9.649-4.231.001V9.651L11.77.002z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        fill: "#fff",
                        stroke: "#fff",
                        "data-name": "사각형 1519",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                stroke: "none",
                                d: "M9.472 2.769l3.424 3.423-.857.857-3.423-3.424z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "none",
                                d: "M9.472 3.476l2.717 2.716-.15.15-2.716-2.717z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CoverLetterWrite);


/***/ }),

/***/ 29229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e$": function() { return /* binding */ getErrorMessage; },
/* harmony export */   "zg": function() { return /* binding */ getErrorCode; }
/* harmony export */ });
/* unused harmony export getErrorMessageFromServer */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_errorMessages__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65155);


var getErrorCode = function(error) {
    var errorCode = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(error, "graphQLErrors[0].extensions.code", "UNKNOWN_ERROR");
    return errorCode;
};
var getErrorMessage = function(error) {
    var errorCode = getErrorCode(error);
    var message = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(_constants_errorMessages__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, errorCode, _constants_errorMessages__WEBPACK_IMPORTED_MODULE_1__/* ["default"].UNKNOWN_ERROR */ .Z.UNKNOWN_ERROR);
    return message;
};
var getErrorMessageFromServer = function(error) {
    var message = get(error, "graphQLErrors[0].message", errorMessages.UNKNOWN_ERROR);
    return message;
};


/***/ }),

/***/ 65342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ imageLoader; },
/* harmony export */   "m": function() { return /* binding */ optimizeImageUrl; }
/* harmony export */ });
var optimizeImageUrl = function(options) {
    if (!options.url) return "";
    return "".concat(options.url, "?d=").concat(options.width, "x").concat(options.height);
};
var imageLoader = function(param) {
    var src = param.src;
    return "".concat(src);
};


/***/ })

}]);